import { Loading, ProfileDocuments as RenderProfileDocuments } from '@/components';
import { useQuery } from '@tanstack/react-query';
import { kycApi } from '@/api/kyc';
import { useSelector } from 'react-redux';
import { Flex } from 'antd';
import { useParams } from 'react-router';

export const ProfileDocuments = ({ referralView = false }) => {
  const { referralToken } = useSelector((state) => state.user);
  const { id: referralId } = useParams();
  const {
    data: requestedDocs,
    refetch,
    isLoading: isLoading1
  } = useQuery({
    queryKey: ['getRequestedDocuments', referralToken],
    queryFn: referralView
      ? () => kycApi.getReferralRequestedDocuments(referralToken)
      : kycApi.getRequestedDocuments,
    enabled: (referralView && !!referralToken) || !referralView,
    refetchIntervalInBackground: 60000,
    refetchInterval: 10000,
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
  const { data: questsDocs, isLoading: isLoading2 } = useQuery({
    queryKey: ['getQuestsDocuments', referralToken],
    queryFn: referralView
      ? () => kycApi.getReferralQuestsDocuments(referralToken)
      : kycApi.getQuestsDocuments,
    enabled: (referralView && !!referralToken) || !referralView,
    refetchIntervalInBackground: 60000,
    refetchInterval: 10000,
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });

  return (
    <div>
      {!isLoading1 && !isLoading2 ? (
        <RenderProfileDocuments
          documents={requestedDocs?.data}
          questsDocs={questsDocs?.data}
          refetchDocs={refetch}
          viewMode={referralView ? 'referral' : 'investor'}
          referralId={referralId}
        />
      ) : (
        <Flex vertical justify='center' align='center' style={{ height: 400 }}>
          <Loading />
        </Flex>
      )}
    </div>
  );
};
